module.exports = __webpack_public_path__ + "static/agbamu-048682129fc5c3537a988ce5eda6a15e.png";